import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";

import cover from "../assets/img/shepherd-farm-cover.webp";
import CrazyIFrame from 'src/components/CrazyIFrame';


export const projectDetails: ProjectInterface = {
    url: "shepherd-farm",
    title: "Shepherd Farm",
    summary: "Run a sheep farm as a loyal dog in Shepherd Farm.",
    description: `In Shepherd Farm, my primary focus was on porting the game to the web while simultaneously enhancing gameplay. As the programmer, I translated the game design ideas into gameplay feature, both for new mechanics and adapting existing ones into a web environment. Additionally, I integrated art assets into the game and UI. I also incorporated external SDKs and plugins to assist data analysis.`,
    year: "2022",
    tags: ["Casual", "Idle Arcade", "WebGL", "Unity"],
    imageSrc: cover,
    hasVideo: false,
    startVideoTime: 0,
    videoSrc: "",
    isCoverType: false,
    haveTags: true,
    projectType: ProjectType.PROFESSIONAL,
    roles: ["Programmer"],
    studio: ["Izyplay Game Studio"],
    technologies: ["Unity", "C#", "WebGL"],
    platforms: ["Web"],
    collaborators: ["[link=Izyplay Game Studio|https://izyplay.com.br/]"],
    highlightColor: "#60151F",
    descriptionTitle: "",
    linkData: [
        { type: 'text', url: "https://www.crazygames.com/game/shepherd-farm" },
    ],
    relatedProjects: ["IzasSupermarket", "MazeDiscover", "CheckMore"],
};


export function ShepherdFarm() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                leftContent={
                    <div className="a-left-no-bg">
                        <CrazyIFrame src="https://www.crazygames.com/embed/shepherd-farm" height={500} title="Shepherd Farm" />
                    </div>
                }
                rightContent={
                    null
                }>
            </ProjectBase>
        </div>
    );
}